import { NavLink, useLocation } from 'react-router-dom'
import { LayoutDashboard, Users, CalendarDays, Wrench, MoreHorizontal } from 'lucide-react'
import { cn } from '../../lib/utils'

const mainLinks = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/kunden', icon: Users, label: 'Kunden' },
  { to: '/besuche', icon: CalendarDays, label: 'Besuche' },
  { to: '/service', icon: Wrench, label: 'Service' },
  { to: '/mehr', icon: MoreHorizontal, label: 'Mehr' },
]

export function BottomNav() {
  const location = useLocation()
  const morePaths = ['/defekte', '/ersatzteile', '/offerten', '/faq', '/einstellungen', '/inventar']
  const isMoreActive = morePaths.some((p) => location.pathname.startsWith(p))

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 safe-area-pb z-40">
      <div className="grid grid-cols-5 max-w-md mx-auto">
        {mainLinks.map(({ to, icon: Icon, label }) => {
          const isMore = to === '/mehr'
          const active = isMore ? isMoreActive : location.pathname === to || (to !== '/' && location.pathname.startsWith(to))
          return (
            <NavLink
              key={to}
              to={to}
              className={cn(
                'flex flex-col items-center justify-center py-2.5 gap-0.5 transition-colors',
                active ? 'text-blue-600' : 'text-gray-400'
              )}
            >
              <Icon size={22} strokeWidth={active ? 2.5 : 1.8} />
              <span className="text-[10px] font-medium">{label}</span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
